/**
 * Angular Application:
 * Main application bootstrap
 *
 * @category Modules
 * @package App
 * @author Chris <chriswelland@yellostudio.co.uk>
 * @copyright (c) 2016, Yello Studio
 * @version 0.1
 */

(function(){

    'use strict';

    var Config = function($interpolateProvider, $httpProvider)
    {
      $interpolateProvider.startSymbol('({').endSymbol('})');
      $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
      $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8';
      $httpProvider.defaults.transformRequest = function(obj) {
        var str = [];
        for(var p in obj){
        	if(typeof obj[p] == "undefined"){
        		obj[p] = '';
        	}
     	    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      	}
        return str.join("&");
      };
      $httpProvider.defaults.withCredentials = true;
    };


    angular.module('App', []).config(Config);
})();
